import { projectsId } from '../../../config/constants.js';

export default (id: string) => {
    ($$(id) as webix.ui.text).setValue('');
    const currentProjectId = ($$(projectsId) as webix.ui.combo).getValue();
    return currentProjectId ? $$(id).enable() : $$(id).disable();
};
